/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.51.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateReferenceTableItem,
  CreateReferenceTableItem201,
  CreateReferenceTableItemParams,
  DeleteReferenceTableItemParams,
  ForbiddenErrorResponse,
  GetReferenceTableItemParams,
  GetReferenceTableItemsParams,
  GetTp2LookupTableItemIdParams,
  Id,
  ReferenceTableItem,
  Tp2LookupTableItemId,
  UnauthorizedErrorResponse,
  UpdateReferenceTableItem,
  UpdateReferenceTableItemParams,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

/**
 * @summary Get reference table items
 */
export const getReferenceTableItems = (
  tenantId: Id,
  params: GetReferenceTableItemsParams,
  signal?: AbortSignal
) => {
  return httpClient<ReferenceTableItem[]>({
    url: `/query-service/tenant/${tenantId}/reference-table-information/get-items`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetReferenceTableItemsQueryKey = (
  tenantId?: Id,
  params?: GetReferenceTableItemsParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "reference-table-information",
    "get-items",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReferenceTableItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferenceTableItems>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItems>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReferenceTableItemsQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReferenceTableItems>>
  > = ({ signal }) => getReferenceTableItems(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferenceTableItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReferenceTableItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReferenceTableItems>>
>;
export type GetReferenceTableItemsQueryError = ForbiddenErrorResponse | void;

export function useGetReferenceTableItems<
  TData = Awaited<ReturnType<typeof getReferenceTableItems>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceTableItems>>,
          TError,
          Awaited<ReturnType<typeof getReferenceTableItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReferenceTableItems<
  TData = Awaited<ReturnType<typeof getReferenceTableItems>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceTableItems>>,
          TError,
          Awaited<ReturnType<typeof getReferenceTableItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReferenceTableItems<
  TData = Awaited<ReturnType<typeof getReferenceTableItems>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get reference table items
 */

export function useGetReferenceTableItems<
  TData = Awaited<ReturnType<typeof getReferenceTableItems>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReferenceTableItemsQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get reference table item
 */
export const getReferenceTableItem = (
  tenantId: Id,
  params: GetReferenceTableItemParams,
  signal?: AbortSignal
) => {
  return httpClient<ReferenceTableItem>({
    url: `/query-service/tenant/${tenantId}/reference-table-information/get-item`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetReferenceTableItemQueryKey = (
  tenantId?: Id,
  params?: GetReferenceTableItemParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "reference-table-information",
    "get-item",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReferenceTableItemQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferenceTableItem>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItem>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReferenceTableItemQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReferenceTableItem>>
  > = ({ signal }) => getReferenceTableItem(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferenceTableItem>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReferenceTableItemQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReferenceTableItem>>
>;
export type GetReferenceTableItemQueryError = ForbiddenErrorResponse | void;

export function useGetReferenceTableItem<
  TData = Awaited<ReturnType<typeof getReferenceTableItem>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItem>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceTableItem>>,
          TError,
          Awaited<ReturnType<typeof getReferenceTableItem>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReferenceTableItem<
  TData = Awaited<ReturnType<typeof getReferenceTableItem>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItem>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferenceTableItem>>,
          TError,
          Awaited<ReturnType<typeof getReferenceTableItem>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReferenceTableItem<
  TData = Awaited<ReturnType<typeof getReferenceTableItem>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItem>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get reference table item
 */

export function useGetReferenceTableItem<
  TData = Awaited<ReturnType<typeof getReferenceTableItem>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetReferenceTableItemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReferenceTableItem>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReferenceTableItemQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the tp2_lookup_table_item_id stored on the reference_table_item identified by
referenceTableItemId. The value may be null when the row exists but has no TP2 mapping.
Used by tp2-event-adapter to translate TP3 reference values to their TP2 equivalents
without needing to know the parent reference_table.uuid.

 * @summary Get the TP2 lookup table item id for a TP3 reference_table_item.uuid
 */
export const getTp2LookupTableItemId = (
  tenantId: Id,
  params: GetTp2LookupTableItemIdParams,
  signal?: AbortSignal
) => {
  return httpClient<Tp2LookupTableItemId>({
    url: `/query-service/tenant/${tenantId}/reference-table-information/get-tp2-lookup-table-item-id`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTp2LookupTableItemIdQueryKey = (
  tenantId?: Id,
  params?: GetTp2LookupTableItemIdParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "reference-table-information",
    "get-tp2-lookup-table-item-id",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTp2LookupTableItemIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetTp2LookupTableItemIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTp2LookupTableItemIdQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTp2LookupTableItemId>>
  > = ({ signal }) => getTp2LookupTableItemId(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTp2LookupTableItemIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTp2LookupTableItemId>>
>;
export type GetTp2LookupTableItemIdQueryError = ForbiddenErrorResponse | void;

export function useGetTp2LookupTableItemId<
  TData = Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetTp2LookupTableItemIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
          TError,
          Awaited<ReturnType<typeof getTp2LookupTableItemId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTp2LookupTableItemId<
  TData = Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetTp2LookupTableItemIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
          TError,
          Awaited<ReturnType<typeof getTp2LookupTableItemId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTp2LookupTableItemId<
  TData = Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetTp2LookupTableItemIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the TP2 lookup table item id for a TP3 reference_table_item.uuid
 */

export function useGetTp2LookupTableItemId<
  TData = Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetTp2LookupTableItemIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTp2LookupTableItemId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTp2LookupTableItemIdQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create reference table item
 */
export const createReferenceTableItem = (
  referenceTableId: Id,
  referenceTableItemId: Id,
  createReferenceTableItem: CreateReferenceTableItem,
  params: CreateReferenceTableItemParams,
  signal?: AbortSignal
) => {
  return httpClient<CreateReferenceTableItem201 | void>({
    url: `/command-service/reference-table/aggregate/reference-table/${referenceTableId}/items/${referenceTableItemId}/add-reference-table-item`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createReferenceTableItem,
    params,
    signal,
  });
};

export const getCreateReferenceTableItemMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReferenceTableItem>>,
    TError,
    {
      referenceTableId: Id;
      referenceTableItemId: Id;
      data: CreateReferenceTableItem;
      params: CreateReferenceTableItemParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReferenceTableItem>>,
  TError,
  {
    referenceTableId: Id;
    referenceTableItemId: Id;
    data: CreateReferenceTableItem;
    params: CreateReferenceTableItemParams;
  },
  TContext
> => {
  const mutationKey = ["createReferenceTableItem"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReferenceTableItem>>,
    {
      referenceTableId: Id;
      referenceTableItemId: Id;
      data: CreateReferenceTableItem;
      params: CreateReferenceTableItemParams;
    }
  > = (props) => {
    const { referenceTableId, referenceTableItemId, data, params } =
      props ?? {};

    return createReferenceTableItem(
      referenceTableId,
      referenceTableItemId,
      data,
      params
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReferenceTableItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReferenceTableItem>>
>;
export type CreateReferenceTableItemMutationBody = CreateReferenceTableItem;
export type CreateReferenceTableItemMutationError =
  void | UnauthorizedErrorResponse;

/**
 * @summary Create reference table item
 */
export const useCreateReferenceTableItem = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createReferenceTableItem>>,
      TError,
      {
        referenceTableId: Id;
        referenceTableItemId: Id;
        data: CreateReferenceTableItem;
        params: CreateReferenceTableItemParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createReferenceTableItem>>,
  TError,
  {
    referenceTableId: Id;
    referenceTableItemId: Id;
    data: CreateReferenceTableItem;
    params: CreateReferenceTableItemParams;
  },
  TContext
> => {
  const mutationOptions = getCreateReferenceTableItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateReferenceTableItem = (
  referenceTableId: Id,
  referenceTableItemId: Id,
  updateReferenceTableItem: UpdateReferenceTableItem,
  params: UpdateReferenceTableItemParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/reference-table/aggregate/reference-table/${referenceTableId}/items/${referenceTableItemId}/update-reference-table-item`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateReferenceTableItem,
    params,
    signal,
  });
};

export const getUpdateReferenceTableItemMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReferenceTableItem>>,
    TError,
    {
      referenceTableId: Id;
      referenceTableItemId: Id;
      data: UpdateReferenceTableItem;
      params: UpdateReferenceTableItemParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReferenceTableItem>>,
  TError,
  {
    referenceTableId: Id;
    referenceTableItemId: Id;
    data: UpdateReferenceTableItem;
    params: UpdateReferenceTableItemParams;
  },
  TContext
> => {
  const mutationKey = ["updateReferenceTableItem"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReferenceTableItem>>,
    {
      referenceTableId: Id;
      referenceTableItemId: Id;
      data: UpdateReferenceTableItem;
      params: UpdateReferenceTableItemParams;
    }
  > = (props) => {
    const { referenceTableId, referenceTableItemId, data, params } =
      props ?? {};

    return updateReferenceTableItem(
      referenceTableId,
      referenceTableItemId,
      data,
      params
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReferenceTableItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReferenceTableItem>>
>;
export type UpdateReferenceTableItemMutationBody = UpdateReferenceTableItem;
export type UpdateReferenceTableItemMutationError =
  void | UnauthorizedErrorResponse;

export const useUpdateReferenceTableItem = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateReferenceTableItem>>,
      TError,
      {
        referenceTableId: Id;
        referenceTableItemId: Id;
        data: UpdateReferenceTableItem;
        params: UpdateReferenceTableItemParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateReferenceTableItem>>,
  TError,
  {
    referenceTableId: Id;
    referenceTableItemId: Id;
    data: UpdateReferenceTableItem;
    params: UpdateReferenceTableItemParams;
  },
  TContext
> => {
  const mutationOptions = getUpdateReferenceTableItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete reference table item
 */
export const deleteReferenceTableItem = (
  referenceTableId: Id,
  referenceTableItemId: Id,
  params: DeleteReferenceTableItemParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/reference-table/aggregate/reference-table/${referenceTableId}/items/${referenceTableItemId}/delete-reference-table-item`,
    method: "POST",
    params,
    signal,
  });
};

export const getDeleteReferenceTableItemMutationOptions = <
  TError = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReferenceTableItem>>,
    TError,
    {
      referenceTableId: Id;
      referenceTableItemId: Id;
      params: DeleteReferenceTableItemParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReferenceTableItem>>,
  TError,
  {
    referenceTableId: Id;
    referenceTableItemId: Id;
    params: DeleteReferenceTableItemParams;
  },
  TContext
> => {
  const mutationKey = ["deleteReferenceTableItem"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReferenceTableItem>>,
    {
      referenceTableId: Id;
      referenceTableItemId: Id;
      params: DeleteReferenceTableItemParams;
    }
  > = (props) => {
    const { referenceTableId, referenceTableItemId, params } = props ?? {};

    return deleteReferenceTableItem(
      referenceTableId,
      referenceTableItemId,
      params
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReferenceTableItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReferenceTableItem>>
>;

export type DeleteReferenceTableItemMutationError = void;

/**
 * @summary Delete reference table item
 */
export const useDeleteReferenceTableItem = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReferenceTableItem>>,
      TError,
      {
        referenceTableId: Id;
        referenceTableItemId: Id;
        params: DeleteReferenceTableItemParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReferenceTableItem>>,
  TError,
  {
    referenceTableId: Id;
    referenceTableItemId: Id;
    params: DeleteReferenceTableItemParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteReferenceTableItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
